import { Link } from 'gatsby'
import { StaticImage } from 'gatsby-plugin-image'
import React from 'react'

const Footer = (): React.ReactElement => (
  <footer className="footer">
      <div className="footer__content">
        <StaticImage
          src="../assets/logo-default.svg"
          placeholder="none"
          className="footer__img"
          alt="qibri logo, a hummingbird"
        />

        <div className="footer__text">
          Untere Weißgerberstraße 43{''}
          <br></br>{''}
          1030 Wien, Österreich
        </div>
      </div>

    <ul className="footer__list">
      <li className="footer__list-item"><Link to="/imprint" title ="Read our imprint">
        Imprint</Link></li>
    </ul>
  </footer>
)

export default Footer
